import Loader from '@anm/components/Loader';
import TitleBlock from '@anm/components/TitleBlock';
import Button from '@anm/components/buttons/Button';
import { ButtonWrapper } from '@anm/components/form/FieldWithButton/Wrapper';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { subTitleStyles } from '../../Wrapper';

const wrapperOnMobiles = media.tablet`
  padding: 0 19px;
`;

const thumbnailWrapperOnMobiles = media.tablet`
  text-align: center;
`;

export const Wrapper = styled.div`
  padding: 31px 0 20px 0;
  ${wrapperOnMobiles};

  textarea {
    min-height: 110px;
  }

  ${ButtonWrapper} {
    min-width: 170px;
  }
`;

export const ThumbnailWrapper = styled.div`
  ${thumbnailWrapperOnMobiles};
`;

export const DownloadlThumbnail = styled(Button)<{ disabled?: boolean }>`
  display: inline-block;
  margin: 20px auto 0;
  user-select: none;
  min-width: 170px;

  ${({ disabled }) =>
    disabled &&
    css`
      color: #919eaa;
      pointer-events: none;
    `}
`;

export const Subtitle = styled(TitleBlock)`
  ${subTitleStyles};
  margin-bottom: 7px;
`;

export const LinkWrapper = styled.div`
  margin: 18px 0;
`;

export const LinkInput = styled.input`
  display: block;
  width: 100%;
  background: #fff;
  height: 40px;
  outline: none;
  border: 1px solid #ccdde6;
  box-sizing: border-box;
  border-radius: 5px;
  font-family: Inter;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #292a2b;
  padding: 0 12px;
`;

export const LoaderWrapper = styled(Loader)`
  margin-top: 100px;
`;
